import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import axios from "axios";
import DialogActions from "@mui/material/DialogActions";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const materialTheme = createTheme({
  // set default for now
});

export default function SignIn(props) {
  const classes = useStyles();
  const [user, setUser] = useState({
    username: "",
    password: "",
    isAgree: true,
  });
  const [showProgress, setShowProgress] = useState(false);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [isAgreed, setIsAgreed] = useState(true);
  const inputOnChanged = (event) => {
    setUser({ ...user, [event.target.name]: event.target.value });
  };

  function messageDialog() {
    return (
      <>
        <Dialog
          open={openMessageDialog}
          fullWidth={true}
          maxWidth={"lg"}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography variant="h6" component="h2" style={{ color: "red" }}>
              {"Message"}
            </Typography>
            {loginMessage}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenMessageDialog(false);
              }}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  function progressDialog() {
    return (
      <>
        <Dialog fullWidth={true} maxWidth={"sm"} open={showProgress}>
          <DialogContent>
            <DialogContentText>
              Checking credential... Please wait...
            </DialogContentText>

            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  const onFormSubmit = (event) => {
    event.preventDefault();

    setShowProgress(true);

    // axios.defaults.baseURL = 'http://192.168.0.106/transactiapi';
    // axios.defaults.headers.common['Authorization'] ='12';
    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

    // axios({
    //   method: 'post',
    //   url: '/User/login',
    //   data: objectToFormData(user)
    // });

    const options = {
      method: "POST",
      url: "/User/login",
      data: objectToFormData(user),
    };
    axios(options)
      .then((res) => {
        setShowProgress(false);

        const response = res.data;
        const isSucess = response.is_success;

        if (isSucess) {
          if (response.hasOwnProperty("has_mfa_settings") && response.hasOwnProperty("has_mfa_email_otp_sent")) {
            const { has_mfa_settings, has_mfa_email_otp_sent, token, has_mfa_token } = response;

            if (has_mfa_settings) {
              if (has_mfa_settings && has_mfa_email_otp_sent) {
                props.setIsMultiFactorAuthentication(true);
                props.setResponseLoginToken(token);
                props.setResponseLoginMfaToken(has_mfa_token);
                sessionStorage.setItem("mfa_info_token", has_mfa_token);
                sessionStorage.setItem("mfa_info_local_token", token);
              }
            } else {
              localStorage.setItem("token", response.token);
              props.setIsLogin(true);
            }

            
          } else {
            localStorage.setItem("token", response.token);
            props.setIsLogin(true);
          }
          
      
        } else {
          const message = response.message;
          setLoginMessage(message);
          setOpenMessageDialog(true);
        }
      })
      .catch((error) => {
        setShowProgress(false);
        setLoginMessage(error.message);

        setOpenMessageDialog(true);
      });
  };
  const handleCheckboxChange = (event) => {
    setIsAgreed(event.target.checked);
    setUser((prevUser) => ({ ...prevUser, isAgree: event.target.checked }));

    if (isAgreed) {
      setLoginMessage("You must agree to the Terms and Conditions.");
      setOpenMessageDialog(true);
    }
  };

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate onSubmit={onFormSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="username"
            autoComplete="email"
            autoFocus
            onChange={inputOnChanged}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={inputOnChanged}
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox checked={isAgreed} onChange={handleCheckboxChange} />
              }
              label={
                <Typography>
                  <Link
                    href="#"
                    variant="body2"
                    style={{ color: "black" }}
                    onClick={() => {
                      props.setIsEula(true);
                    }}
                  >
                    {"I Agree to the Terms and Conditions"}
                  </Link>
                </Typography>
              }
            />
          </FormGroup>
          {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!isAgreed}
          >
            Sign In
          </Button>
          <Grid container>
            <Grid item xs>
              <Link
                href="#"
                variant="body2"
                style={{ color: "black" }}
                onClick={() => {
                  props.setIsResetPassword(true);
                }}
              >
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link
                href="#"
                variant="body2"
                style={{ color: "black" }}
                // onClick={() => {
                //   props.setIsSignUp(true);
                // }}
                onClick={() => {
                  setLoginMessage(
                    "Please contact your GTM for user enrollment/registration."
                  );
                  setOpenMessageDialog(true);
                }}
              >
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>{/* <Copyright /> */}</Box>
      {progressDialog()}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>{messageDialog()}</ThemeProvider>
      </StyledEngineProvider>
    </Container>
  );
}
